exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/node_modules/css-loader?{"sourceMap":false,"import":false}!E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles